export enum PlaceActionType {
  /*
   | ---------------------------------------------------------------------------
   | Place Creation Actions
   | ---------------------------------------------------------------------------
   |
   | These actions are for creating a new places.
   |
   */
  CreatePlaceError = 'place/CREATE_ERROR',
  CreatePlaceRequest = 'place/CREATE_REQUEST',
  CreatePlaceSuccess = 'place/CREATE_SUCCESS',

  /*
   | ---------------------------------------------------------------------------
   | Place Deletion Actions
   | ---------------------------------------------------------------------------
   |
   | These actions are for creating a new places.
   |
   */
  DeletePlaceError = 'place/DELETE_ERROR',
  DeletePlaceRequest = 'place/DELETE_REQUEST',
  DeletePlaceSuccess = 'place/DELETE_SUCCESS',

  /*
   | ---------------------------------------------------------------------------
   | Place Load Actions
   | ---------------------------------------------------------------------------
   |
   | These actions are for loading and unloading existing places into/out of
   | the store from the server.
   |
   */
  LoadPlace = 'place/LOAD',
  LoadPlaceError = 'place/LOAD_ERROR',
  LoadPlaceRequest = 'place/LOAD_REQUEST',
  LoadPlaceSuccess = 'place/LOAD_SUCCESS',
  UnloadPlace = 'place/UNLOAD',

  /*
   | ---------------------------------------------------------------------------
   | Place Setter Actions
   | ---------------------------------------------------------------------------
   |
   | These actions set the value of some field of an individual place currently
   | in the store.
   |
   */
  SetPlaceCategoryIds = 'place/SET_CATEGORY_IDS',
  SetPlaceDescription = 'place/SET_DESCRIPTION',
  SetPlaceError = 'place/SET_ERROR',
  SetPlaceLocationId = 'place/SET_LOCATION_ID',
  SetPlaceName = 'place/SET_NAME',
  SetPlacePageId = 'place/SET_PAGE_ID',
  SetPlacePageTitle = 'place/SET_PAGE_TITLE',
  SetPlacePosterImages = 'place/SET_POSTER_IMAGES',
  SetPlaceRecurrenceRules = 'place/SET_RECURRENCE_RULES',
  SetPlaceStatus = 'place/SET_STATUS',
  SetPlaceTagIds = 'place/SET_TAG_IDS',
  SetPlaceTags = 'place/SET_TAGS', // TODO: this will go away w/ new tag editor.
  SetPlaceLocation = 'place/SET_LOCATION',

  /*
   | ---------------------------------------------------------------------------
   | Place Update Actions
   | ---------------------------------------------------------------------------
   |
   | These actions are for updating existing places.
   |
   */
  UpdatePlaceError = 'place/UPDATE_ERROR',
  UpdatePlaceRequest = 'place/UPDATE_REQUEST',
  UpdatePlaceSuccess = 'place/UPDATE_SUCCESS',
}
